import React, {useState, useEffect} from 'react';
import * as S from './AddCash.styles';
import IconSelector from '@ibibo/icon-selector';
import {getCookie} from '../../../../utils/getCookie';

const addAmountValue = [100000, 200000, 500000, 1000000];
const addAmountValueAED = [1000, 2500, 5000, 10000];
const raiseNeftRequestProcessDocUrl =
  'https://mypartnerimgak.mmtcdn.com/0UWRs5fxcvYuntRD5UAppkvBXhaYQ2rs/wblSKoHeeh.pdf';

const AddCash = props => {
  const {
    addBalanceToWallet,
    openPayment,
    closePayments,
    neftDetailsCaller,
    blacklistBlock,
    showWalletNew,
    showNefyPay,
    is_sub_user,
  } = props;

  const ccdeCookie = getCookie('ccde');
  const [inputValue, setInputValue] = useState(ccdeCookie == 'AE' ? 3000 : 100000);
  const [error, setError] = useState('');

  const addBalance = () => {
    if (inputValue > 0) {
      addBalanceToWallet(inputValue);
    } else {
      setError('Please enter recharge amount to add balance');
    }
  };

  const onInputChange = val => {
    if (val > 1000000) {
      setError('Please enter amount less than or equal to ₹10,00,000');
    } else if (val === '' || val === 0) {
      setError('Please enter recharge amount to add balance');
      setInputValue(val);
    } else if (/^\d+$/.test(val)) {
      setError('');
      setInputValue(val);
    }
  };

  const openRefundRequestPage = () => {
    window.open('/myrefundrequests/', '_self');
  };

  return (
    <S.AddCashMainWrap>
      <S.AddCashInnerWrap>
        <S.AddCashHeadWrap>
          <S.AddCashHeadTextWrap>
            <S.AddCashIconWrap>
              {ccdeCookie === 'AE' ? (
                <img
                  width={36}
                  src="https://assets-gos3.goibibo.com/myp_MYCASH_AED-1678423545.svg"
                />
              ) : (
                <IconSelector iconKey="mycash" />
              )}
            </S.AddCashIconWrap>
            <S.AddCashText>Add My Cash</S.AddCashText>
          </S.AddCashHeadTextWrap>
          {/* <S.AddCashHeadInfoWrap>
            <S.AddCashInfoText>Get 1% additional <IconSelector iconKey='rewardbonussmall' props={{width:'1.6rem', height:'1.6rem'}}/> Promo cash with a recharge of at least Rs. 10,000</S.AddCashInfoText>
          </S.AddCashHeadInfoWrap> */}
        </S.AddCashHeadWrap>
        {(showNefyPay && (
          <S.NeftRechargeBlock>
            <S.RecommendedTag>
              <S.RecommendedText>Recommended Method</S.RecommendedText>
            </S.RecommendedTag>
            <S.NeftInnerBlock>
              <S.NeftInfoWrap>
                <S.NeftHeadText>
                  {ccdeCookie === 'AE' ? 'Recharge via Account Deposit' : 'Recharge via NEFT/RTGS'}
                  <S.NewTagNeft>New</S.NewTagNeft>
                </S.NeftHeadText>
                <S.NeftInfoText>
                  {ccdeCookie === 'AE'
                    ? 'Transfer money to myPartner account number to load money to your myPartner wallet.'
                    : `Transfer money to your Unique Virtual Account number to load money to your
                  myPartner wallet.`}{' '}
                  <br />
                  {ccdeCookie !== 'AE' &&
                    'Wallet gets automatically recharged within 3hrs of bank transfer'}
                  {ccdeCookie === 'AE' ? (
                    <S.NoteText>
                      Note: For any bank transfer or cash deposit made after 9:30 PM GST, wallet
                      top-up will be processed by 9 AM GST the following day.
                    </S.NoteText>
                  ) : null}
                </S.NeftInfoText>
              </S.NeftInfoWrap>
              <S.NeftDetailBtnWrap>
                <S.NeftDetailBtn onClick={neftDetailsCaller}>View Account Details</S.NeftDetailBtn>
                <S.NeftDetailBtn>
                  <a onClick={openRefundRequestPage}>Submit Deposit Request</a>
                </S.NeftDetailBtn>
              </S.NeftDetailBtnWrap>
            </S.NeftInnerBlock>
          </S.NeftRechargeBlock>
        )) ||
          null}

        {showWalletNew && showNefyPay && (
          <S.OptionalBlock>
            <S.OptionalText>- OR -</S.OptionalText>
          </S.OptionalBlock>
        )}

        <S.AddCashBlockOuter>
          {(!showWalletNew && (
            <>
              {(showNefyPay && (
                <S.AddCashDisabledBlock>
                  <S.DisabledText>
                    Wallet recharge through other payment options is currently disabled due to an
                    upgradation activity. We encourage you to do use the{' '}
                    <strong>NEFT facility</strong> to recharge your wallet.
                  </S.DisabledText>
                  <S.DisabledText>
                    You can continue to use the payment options available at the time of checkout.
                    Available <strong>My Cash</strong> balance can be used for both Hotels and
                    Flight transactions during checkout.
                  </S.DisabledText>
                </S.AddCashDisabledBlock>
              )) || (
                <S.AddCashDisabledBlock>
                  <S.DisabledText>
                    This section is currently disabled due to an upgradation activity. You can
                    continue to use the payment options available at the time of checkout. Available{' '}
                    <strong>My Cash</strong> balance can be used for both Hotels and Flight
                    transactions during checkout.
                  </S.DisabledText>
                </S.AddCashDisabledBlock>
              )}
            </>
          )) ||
            null}
          <S.RechargeInfoWrap disabled={!showWalletNew}>
            <S.RechargeInfoHeadLabel>Recharge Online</S.RechargeInfoHeadLabel>
            <S.RechargeInfoLabel>Enter Recharge Amount</S.RechargeInfoLabel>
            <S.ReachargeInput
              type="text"
              value={inputValue}
              onChange={event => onInputChange(event.target.value)}
            />
            {(error !== '' && <S.ReachargeErrorText>{error}</S.ReachargeErrorText>) || null}
          </S.RechargeInfoWrap>

          <S.RechargeOptionWrap>
            <S.ReachargeOptionWrap>
              {ccdeCookie === 'AE'
                ? addAmountValueAED.map(item => (
                    <S.ReachargeOptionTag
                      key={item}
                      onClick={() => onInputChange(item)}
                      disabled={!showWalletNew}
                    >
                      <S.AedText>AED &nbsp;</S.AedText>
                      <S.OptionText>{item.toLocaleString('en-IN')}</S.OptionText>
                    </S.ReachargeOptionTag>
                  ))
                : addAmountValue.map(item => (
                    <S.ReachargeOptionTag
                      key={item}
                      onClick={() => onInputChange(item)}
                      disabled={!showWalletNew}
                    >
                      <IconSelector
                        iconKey="rupee"
                        props={{width: '0.9rem', height: '0.9rem', fill: '#000'}}
                      />
                      <S.OptionText>{item.toLocaleString('en-IN')}</S.OptionText>
                    </S.ReachargeOptionTag>
                  ))}
            </S.ReachargeOptionWrap>
            {showWalletNew ? (
              <S.ReachargeButtonWrap onClick={addBalance}>
                <S.RechargeButton>Add Balance</S.RechargeButton>
              </S.ReachargeButtonWrap>
            ) : (
              <S.ReachargeButtonWrap disabled={openPayment}>
                <S.RechargeButtonDisabled>Add Balance</S.RechargeButtonDisabled>
              </S.ReachargeButtonWrap>
            )}
          </S.RechargeOptionWrap>
        </S.AddCashBlockOuter>
      </S.AddCashInnerWrap>
    </S.AddCashMainWrap>
  );
};

export default AddCash;
